import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import StatsList from '../../components/StatsLocker/List';
import actions from 'actions';

const {
  getStats,
} = actions;

class StatsLocker extends PureComponent {
  componentDidMount() {
    const {getStats, meta} = this.props;
    getStats({
      ...meta,
      page: 1,
    });
  }

  nextPage = () => {
    const {getStats, meta} = this.props;
    getStats({
      ...meta,
      page: meta.page + 1,
    });
    // switch (webinarType) {
    //   case UPCOMING_WEBINARS:
    //     this.setState(
    //       {
    //         page: { ...this.state.page, upcoming: this.state.page.upcoming + 1 }
    //       },
    //       () => this.props.loadUpcomingWebinars(this.state.page.upcoming, params)
    //     );
    //     break;
    //   case CURRENT_WEBINARS:
    //     this.setState(
    //       {
    //         page: { ...this.state.page, current: this.state.page.current + 1 }
    //       },
    //       () => this.props.loadCurrentWebinars(this.state.page.current, params)
    //     );
    //     break;
    //   case PREVIOUS_WEBINARS:
    //     this.setState(
    //       {
    //         page: { ...this.state.page, previous: this.state.page.previous + 1 }
    //       },
    //       () => this.props.loadPreviousWebinars(this.state.page.previous, params)
    //     );
    //     break;
    // }
  };

  render() {
    const {stats, user, meta} = this.props;
    return (
      <main className="site--width">
        <div className="container_cpd row">
          <h2 className="main_title">
            STATS LOCKER
          </h2>
          <StatsList stats={stats} user={user} />
          {meta.pages > meta.page && <a className="more_item" href="javascript:void(0)" onClick={this.nextPage}>LOAD MORE</a>}
        </div>
      </main>
    );
  }
};

const mapStateToProps = ({stats, users}) => ({
  meta: stats.meta,
  stats: stats.stats,
  user: users.user,
});

const mapDispatchToProps = (dispatch) => ({
  getStats: meta => dispatch(getStats(meta)),
})

export default connect(mapStateToProps, mapDispatchToProps)(StatsLocker);



// WEBPACK FOOTER //
// ./src/containers/StatsLocker/StatsLocker.js